import React, { ReactElement, SVGAttributes } from 'react';
import classNames from 'classnames';

import './svg.scss';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface SVGProps extends SVGAttributes<any> {
    path: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

const Svg: React.FC<SVGProps> = ({ path: SvgComponent, className, ...props }): ReactElement => {
    const svgClasses = classNames(className, 'svg');

    return (
        <SvgComponent className={svgClasses} {...props} />
    );
};

export default Svg;
